import Swal from 'sweetalert2';

export const actionErrorConnection = (error, message) => {

    if(error.toString() === 'Error: Network Error'){
        Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al establecer conexión con el servidor. Recargar página.',
                showConfirmButton: true,
                confirmButtonText: 'Aceptar'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
    }else{
        if(message){
            const errorType = error.response?.data?.state || error.response?.data?.mensaje || error.response?.data?.estado
            Swal.fire({
                icon: 'error',
                title: 'Error',
                html: `${message} 
                <br>
                ${errorType}`,
                showConfirmButton: true,
                confirmButtonText: 'Aceptar'
            });
        }
    }
}